import React from "react";
import { getTitleCase } from "../../../../Utils/simulaciones/simulaciones";
import { RVEOModalitySimulation } from "../../../../interfaces/rveoSimulations";

interface RVEOModalityProps {
  modality: RVEOModalitySimulation;
  isLast?: boolean;
}

const RVEOModality: React.FC<RVEOModalityProps> = ({
  modality,
  isLast = false,
}) => {
  return (
    <div
      className="card-verify"
      style={{
        border: "3px solid #d7dbf5",
        marginTop: "0px",
        padding: "24px 32px 40px",
      }}
    >
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Modalidad</div>
          <div className="card-verify__data">
            {modality.modalidad || "-"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Moneda</div>
          <div className="card-verify__data">
            {getTitleCase(modality.moneda || "-")}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Cobertura</div>
          <div className="card-verify__data">
            {modality.cobertura || "-"}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Derecho a Crecer</div>
          <div className="card-verify__data">
            {modality.derechoCrecer || "-"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Gratificación</div>
          <div className="card-verify__data">
            {modality.gratificacion || "-"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Segundo Tramo</div>
          <div className="card-verify__data">
            {modality.segundoTramo || "-"}
          </div>
        </div>
      </div>
      {!isLast && <div className="card-verify__rows-line"></div>}
    </div>
  );
};

export default RVEOModality;
